import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import { useWizard } from '../hooks/WizardProvider';
import useOnboardingSx from '../hooks/useOnboardingSx';

export default function ProgressHeader() {
  const { progressPercent } = useWizard();
  const sx = useOnboardingSx();

  return (
    <Box sx={sx.progressHeader}>
      <Box sx={sx.progressTitleRow}>
        <Typography variant="subtitle1" sx={sx.progressTitle}>
          Guided Setup
        </Typography>
        <Typography variant="body2" sx={sx.progressPercent}>
          {progressPercent}% complete
        </Typography>
      </Box>
      <LinearProgress variant="determinate" value={progressPercent} sx={sx.progressBar} />
    </Box>
  );
}
